import React from "react";
import ChartContainer from "./components/ChartContainer";

function App() {
  return (
    <div>
      <ChartContainer />
    </div>
  );
}

export default App;
